import {useMemo} from 'react';
import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';
import chalk from 'chalk';

const colors = new chalk.Instance({level: 3});

const levelColors = {
  TRACE: colors.magenta,
  DEBUG: colors.cyan,
  INFO: colors.blue,
  WARN: colors.yellow,
  ERROR: colors.red,
};
prefix.reg(log);

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  log.enableAll();
}

prefix.apply(log, {
  format(level, name, timestamp) {
    return `${chalk.gray(`[${timestamp}]`)} ${levelColors[level.toUpperCase()](level)} ${colors.green.bold(`${name}:`)}`;
  },
});

prefix.apply(log.getLogger('critical'), {
  format(level, name, timestamp) {
    return colors.red.bold(`[${timestamp}] ${level} ${name}:`);
  },
});

export const useLogger = (name) => {
  let logger = useMemo(() => {
    return log.getLogger(name);
  }, [name]);
  return logger;
}
